import { render } from "./DefaultCard.vue?vue&type=template&id=328ebd87&scoped=true"
import script from "./DefaultCard.vue?vue&type=script&lang=js"
export * from "./DefaultCard.vue?vue&type=script&lang=js"

import "./DefaultCard.vue?vue&type=style&index=0&id=328ebd87&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328ebd87"]])

export default __exports__